import ContactForm from "@/components/base/ContactForm";
import ContactInfo from "@/components/base/ContactInfo";

export default function Formulaire() {
  return (
    <section id="devis" className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-xl md:text-3xl font-extrabold text-center mb-10 md:mb-14">
          Demandez votre devis gratuit — Réponse sous 24h.
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8 lg:gap-10 min-w-0">
          <ContactForm page="Électrification Nice" subject="Nouveau lead Dépan'Volets — Électrification Nice" variant="wide" showTitle={false} placeholder="Décrivez votre projet d'électrification Nice..." />
          <ContactInfo variant="dark" />
        </div>
      </div>
    </section>
  );
}